export * from './TextHeadingAlignmentFix'
